export const ListingType = {
  None: 0,
  Auction: 1,
  BuyNow: 2,
  CashOffer: 3,
}

export const ListingTypes = [
  { label: 'All', value: ListingType.None },
  { label: 'Auction', value: ListingType.Auction },
  { label: 'Buy Now', value: ListingType.BuyNow },
]

export const NormalizedListingTypes = {
  0: 'All',
  1: 'Auction',
  2: 'Buy Now',
}
